/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandChrome = createReactComponent("brand-chrome", "IconBrandChrome", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-1" }],
  ["path", { d: "M12 9h8.4", key: "svg-2" }],
  ["path", { d: "M14.598 13.5l-4.2 7.275", key: "svg-3" }],
  ["path", { d: "M9.402 13.5l-4.2 -7.275", key: "svg-4" }]
]);

export { IconBrandChrome as default };
//# sourceMappingURL=IconBrandChrome.js.map
